import { useEffect, useState } from "react";
import {
  useGetUserResultsQuery,
  useResumeTestQuery,
} from "../../redux/API/StartTest/startTestApi";
import { getFullName } from "../../utils";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentQuestion, setCurrentQuestionIndex } from "../../redux/Slices/resultSlice";
import {
  setStartedTestId,
  setResetFilters,
  setQid,
} from "../../redux/Slices/startFullTestSlice";
import { RootState } from "../../redux/Store/store";
import FullTest from "../FullTest";
import TestInstructions from "../../components/Exam/TestInstructions";
import DashboardBackground from "../../components/ReUsableComponents/DashboardBackground";
import HeaderV1 from "../NewDashboard/HeaderV1";
import SideBarV1 from "../NewDashboard/SideBarV1";
import { ResultTab } from "./ResultPageTabs";

const ResultsPage = () => {
  const { data: resultData, isLoading: isResultLoading, refetch: refetchResultsData } = useGetUserResultsQuery("", { refetchOnMountOrArgChange: true });

  const {data,isSuccess,isError,refetch:refetchResumeTestData} = useResumeTestQuery({},{refetchOnMountOrArgChange:true});

  const dispatch = useDispatch();

  const { isTestStarted, isTestInstructionsOpen } = useSelector((state: RootState) => 
    state.root.startFullTest
  )
  
  useEffect(() => {
    localStorage.removeItem("route");
  }, []);

  useEffect(() => {
    if(isSuccess && data){
     let payload = {
       testId : data.testId ?? [],
       testName: data.testname ?? "",
       createdDate: data.createdDate ?? "",
       userTestId : data?.userTestId ?? "",
       isFirstTest : data?.isFirstTest ?? false,
       loading: false,
     }
     dispatch(setStartedTestId(payload));
    }
    if(isError){
     let payload = {
       testId : [],
       testName: "",
       createdDate: "",
       userTestId : "",
       isFirstTest : false,
       loading : false
     }
     dispatch(setStartedTestId(payload));
    }
   },[data, isSuccess, isError, dispatch]);

   useEffect(() => {
     dispatch(setResetFilters());
     dispatch(setQid(""));
     dispatch(setCurrentQuestion(""));
     dispatch(setCurrentQuestionIndex(""));
   }, [dispatch]);

  useEffect(() => {
    if (!isTestStarted) {
      refetchResumeTestData();
      refetchResultsData();
    }
  }, [isTestStarted]);

  return (
    <>
    {isTestStarted ? <FullTest /> : isTestInstructionsOpen ? <TestInstructions /> :
      <DashboardBackground>
        <div className="p-5 flex gap-[1%] w-full">
          {/* Sidebar */}
          <SideBarV1/>

          <section
            className="flex flex-col justify-center items-start gap-[2vh]"
            style={{
              width: "calc(100vw - 240px)",
              height: "calc(100vh - 40px)",
            }}
          >
            <HeaderV1/>

            <div
              className="p-3 w-full flex flex-grow justify-between items-center self-stretch rounded-[28px] border-[0.5px]  border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive"
              style={{ height: "calc(100vh - 12vh - 40px)" }}
            >
              <div className="h-full my-2 w-full">
                <ResultTab
                  resultData={resultData?.data}
                  isLoading={isResultLoading}
                />
              </div>
            </div>
          </section>
        </div>
      </DashboardBackground>
    }
    </>
  );
};

export default ResultsPage;

export type StudentDetail = {
  firstName: string;
  id: string;
  lastName: string;
  county: string;
  school: string;
};
type StudentDetailProps = {
  studentName: string;
  studentDetailData?: StudentDetail[];
  handleStudentSelection?: (id: string) => void;
};

export const StudentCountyDetails = ({
  studentDetailData,
  studentName,
  handleStudentSelection,
}: StudentDetailProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSelect = (id: string, isSelected: boolean) => {
    if (!isSelected) {
      handleStudentSelection?.(id);
    }
    setDropdownOpen(!dropdownOpen);
  };

  const isDropdownAvailable = studentDetailData && studentDetailData.length > 0;

  return (
    <div className="flex flex-col font-gully w-fit items-start gap-[10px] relative">
      <div className="text-lg flex space-x-2 font-bold text-appPrimaryColor z-10">
        <h3>{studentName ?? "-"}</h3>
        {isDropdownAvailable && (
          <button onClick={() => setDropdownOpen(!dropdownOpen)}>
            {dropdownOpen ? (
              <IoIosArrowUp className="w-6 h-6 my-auto" />
            ) : (
              <IoIosArrowDown className="w-6 h-6 my-auto" />
            )}
          </button>
        )}
      </div>

      {dropdownOpen && (
        <div className="absolute z-10 top-6 right-0 bg-white rounded-xl shadow-lg w-48 max-h-52 overflow-y-auto">
          {isDropdownAvailable ? (
            studentDetailData.map((student, index) => {
              const fullName = getFullName(student.firstName, student.lastName);
              const isSelected = fullName === studentName;

              return (
                <button
                  key={student.id}
                  className={`py-[18px] px-[14px] w-full text-base font-gully font-medium text-start hover:bg-appPrimaryColor hover:text-white text-gray-900
                  ${index === 0 ? "rounded-t-xl" : ""}
                  ${
                    index === studentDetailData.length - 1 ? "rounded-b-xl" : ""
                  }
                  ${isSelected ? "bg-appPrimaryColor text-white" : ""}`}
                  onClick={() => handleSelect(student.id, isSelected)}
                >
                  {fullName.length > 12
                    ? `${fullName.substring(0, 12)}...`
                    : fullName}
                </button>
              );
            })
          ) : (
            <div className="py-[18px] px-[14px] text-gray-500">
              No students available
            </div>
          )}
        </div>
      )}
    </div>
  );
};
